/* Sticky mobile buy bar (spec 52).
   Shows the bar under 990px (phones and tablets, where the two-column page
   puts the button at the fold) whenever the primary buy button is out of view,
   above or below the viewport (IntersectionObserver, no scroll listeners). The
   bar mirrors the main submit button's disabled state and label and the main
   price block, so it can never trigger a purchase the main form would not
   allow (e.g. unavailable variant combinations). Without JS the bar stays
   statically hidden. */
(function () {
  'use strict';

  function initStickyBuy(bar) {
    var sectionId = bar.dataset.sectionId;
    var mainButton = document.getElementById('ProductSubmitButton-' + sectionId);
    var stickyButton = bar.querySelector('.bjerve-sticky-buy__submit');
    var priceSource = document.getElementById('price-' + sectionId);
    var priceTarget = bar.querySelector('.bjerve-sticky-buy__price');

    if (!mainButton || !stickyButton || !('IntersectionObserver' in window)) return;

    var mobileQuery = window.matchMedia('(max-width: 989px)');
    var buttonOutOfView = false;

    function updateVisibility() {
      var show = buttonOutOfView && mobileQuery.matches;
      bar.hidden = !show;
      document.documentElement.classList.toggle('bjerve-sticky-buy-visible', show);
    }

    /* The viewport is the root, so the bar shows whenever the main button is
       outside it - below on landing (at 390x844 the form's button sits near
       1 170px) as well as above after scrolling past - and steps aside while
       the main button itself is in view. */
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        buttonOutOfView = !entry.isIntersecting;
      });
      updateVisibility();
    });
    observer.observe(mainButton);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', updateVisibility);
    }

    function syncButton() {
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      var sourceLabel = mainButton.querySelector('span');
      var targetLabel = stickyButton.querySelector('span');
      if (sourceLabel && targetLabel && targetLabel.textContent !== sourceLabel.textContent) {
        targetLabel.textContent = sourceLabel.textContent;
      }
    }
    syncButton();
    new MutationObserver(syncButton).observe(mainButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
      childList: true,
      subtree: true,
      characterData: true
    });

    if (priceSource && priceTarget) {
      var syncPrice = function () {
        var price = priceSource.querySelector('.price');
        if (price) priceTarget.replaceChildren(price.cloneNode(true));
      };
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  document.querySelectorAll('.bjerve-sticky-buy').forEach(initStickyBuy);
})();
